import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=5392f365&scoped=true&"
import script from "./CommentSection.vue?vue&type=script&lang=js&"
export * from "./CommentSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminSection.css?vue&type=style&index=0&id=5392f365&prod&scoped=true&lang=css&"
import style1 from "./CommentSection.vue?vue&type=style&index=1&id=5392f365&prod&scoped=true&lang=css&"
import style2 from "./CommentSection.vue?vue&type=style&index=2&id=5392f365&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392f365",
  null
  
)

export default component.exports